export default {
    newDesign: true,
    title: "¿Estás criando a un niño feliz y seguro? | Kodland",
    downtimeUrl: "http://kodland.org/es",
    parameters: {
      landing_id: "EsQuMy",
      segment: 14,
    },
    startPage: {
      title:
        "¡Realiza el test de 3 minutos y descubre si tus métodos de crianza se basan en mitos anticuados!",
      subtitle:
        "✔️ Elaborado por expertos en educación<br>❤️ Completamente gratuito<br>🎁 Guía exclusiva de crianza consciente al finalizar el test<br>👪 Más de 100 mil padres confían en nosotros",
      image: {
        url: "/welcome/es_content_myths_paid_desk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/es_content_myths_paid_mob2.png",
        style: {
          width: "100%",
        },
      },
      button: " ¡Empieza ahora! 🚀 ",
    },
    stopPage: {
      image: "/welcome/quizV2/no-computer.png",
      title: "¡Gracias por confiar en nuestra plataforma educativa!",
      subtitle:
        "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
    },
    quizRotateBySteps: {
      1: {
        question: "Pegar a los niños, por supuesto, está mal. Pero unos pequeños azotes no hacen daño a nadie",
        answers: [
          "🤔 Creo que sí",
          "🙂 A mí también me pegaron y crecí normal",
          "😳 ¡La violencia nunca es aceptable!",
        ],
      },
      2: {
        typeInfo: "noQuestions",
        imageLink: "/welcome/q1_es.png",
        subtitle: "En 2016, los científicos realizaron un meta-análisis con 160.927 niños. El resultado es claro: los castigos físicos, incluso los «pequeños azotes», tienen un impacto negativo en los niños.",
        button: "¡Entendido!",
      },
      3: {
        question: "Es posible sentirse triste, llorar, admitir errores e incluso mostrar debilidad frente al niño",
        answers: [
          "😤 ¡No, la autoridad no debe tambalearse!",
          "🥺 Soy humano/a, es normal"
        ],
      },
      4: {
        typeInfo: "noQuestions",
        imageLink: "/welcome/q2_es.png",
        subtitle: "Si un padre siempre intenta parecer seguro, el niño desarrollará una visión poco realista de los adultos. Además, no aprenderá a admitir errores ni a resolver conflictos. Un exceso de calma puede generar distancia emocional.",
        button: "Continuar",
      },
      5: {
        question: "Las cosas más importantes en un niño se forman hasta los 3 años, después de eso, el papel de los padres es pequeño",
        answers: [
          "😰 ¿Y si es cierto? ¡No podré corregir errores!",
          "🥱 Entonces ya puedo relajarme",
          "🤨 No lo creo, los niños evolucionan constantemente"
        ],
      },
      6: {
        typeInfo: "noQuestions",
        imageLink: "/welcome/q3_es.png",
        subtitle: "En cada etapa de la vida, hay una actividad principal que impulsa el desarrollo humano. Es fundamental que el niño crezca de manera equilibrada y reciba el apoyo de sus padres en cada fase.",
        button: "¡Genial!",
      },
      7: {
        question: "Lo mejor es proteger al niño de todas las dificultades para que su infancia no se vea afectada",
        answers: [
          "😇 ¡Sí! Ya enfrentará dificultades más adelante",
          "😕 Imposible, crecer ya es difícil",
          "😬 Hay que añadirle dificultades para que sea fuerte"
        ],
      },
      8: {
        typeInfo: "noQuestions",
        imageLink: "/welcome/q4_es.png",
        subtitle: "Lo mejor es evitar experiencias traumáticas para el niño. Pero protegerlo de cada desafío crea una visión poco realista del mundo y le priva de experiencias importantes. Lo más importante es brindarle un apoyo seguro cuando enfrente dificultades.",
        button: "Continuar",
      },
      9: {
        question: "El elogio perjudica al niño",
        answers: [
          "🥺 No, ¡el elogio es importante!",
          "🤐 Sí, de lo contrario, siempre buscará aprobación."
        ],
      },
      10: {
        typeInfo: "noQuestions",
        imageLink: "/welcome/q5_es.png",
        subtitle: "¡El elogio en sí no es malo! Sin embargo, la motivación con la que se da y la forma en que se expresa son clave.",
        button: "Sí, esto es importante",
      },
      11: {
        question:
          "¿Tienes una computadora de escritorio o portátil con la que tu hijo puedo estudiar?",
        answers: [
          "💻 Si",
          {
            answer: "☹️ No",
            stopAnswer: true,
          },
        ],
      },
      12: {
        title: "¿Qué edad tiene tu hijo/a?",
        type: "age",
        button: "",
      },
      13: {
        typeInfo: "noQuestions",
        imageLink: "/welcome/fwd_freetc_latam_pic3_2.png",
        subtitle: "¡Genial, estás en el camino correcto! 🎉 ¿Quieres descubrir más formas de criar a un niño feliz y exitoso? Especial para ti: Guía gratuita de crianza + Clase de prueba de programación.",
        button: "Me interesa",
      },
      14: {
        title: "Rellena el formulario y elige la fecha de la clase",
        typeInfo: "congrats",
        subtitle:
          "Recibe gratis la guía de Kodland y accede a una clase de prueba de programación para tu hijo.",
        button: "¡Empecemos!",
      },
      15: {
        title: "Reserva una clase gratuita",
        type: "one-page-contacts",
        subtitle: "",
        button: "Casi terminamos 🔥",
      },
      16: {
        title: "",
        type: "timeslot",
        subtitle: "",
        button: "",
      },
      17: {
        title:
          "Revisa estos detalles para completar el registro ✨",
        typeInfo: "pc-laptop",
        subtitle:
          "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
        button: "¿Qué más?",
      },
      18: {
        title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
        typeInfo: "whatsapp",
        subtitle:
          "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
        button: "¿Qué más?",
      },
      19: {
        title: "La clase se realizará en nuestra plataforma 💻",
        typeInfo: "classroom",
        subtitle:
          "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
        button: "Entendido ✅",
      },
    },
  };
  